import React from 'react';

const WarningIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g fill="none" fillRule="evenodd">
      <g fill="#FEAA22" fillRule="nonzero">
        <g>
          <g>
            <g>
              <path
                d="M2.47 18h15.06c1.54 0 2.5-1.67 1.73-3L11.73 1.99c-.77-1.33-2.69-1.33-3.46 0L.74 15c-.77 1.33.19 3 1.73 3zM10 11c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1zm1 4H9v-2h2v2z"
                transform="translate(-296 -382) translate(96 347) translate(200 35) translate(2 2)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default WarningIcon;
